import { useQuery } from 'src/modules/apollo';
import { useAppConfig } from 'src/modules/appConfig';
import type { Card, WithTypeName } from 'src/types';
import * as Schema from 'src/types/graphql';

const buildSuggestions = (
  suggestions?: Schema.Maybe<WithTypeName<Schema.ProfileSuggestion[]>>,
) =>
  suggestions
    ? suggestions.map((suggestion) => ({
        ...suggestion,
        id: suggestion.action?.context?.card as Card,
      }))
    : [];

export const useSuggestions = () => {
  const { zone, language: languageCode } = useAppConfig();
  const { data, loading, error } = useQuery(Schema.GetSuggestionsDocument, {
    variables: { zone, languageCode },
  });

  const suggestions =
    loading || error
      ? []
      : buildSuggestions(
          data?.viewer?.profileSuggestions as Schema.Maybe<
            WithTypeName<Schema.ProfileSuggestion[]>
          >,
        );

  return { suggestions, loading, error };
};
